import React from 'react';
import { searchIcon } from 'assets/icons';

const SearchField = ({
  searchTerm, setSearchTerm, onSubmit, className, label, buttonLabel,
}: {
  searchTerm: string | null,
  setSearchTerm: (searchTerm: string) => void,
  onSubmit?: () => void
  className?: string
  label?: string,
  buttonLabel?: string,
}) => {
  const handleSearchKeyDown = (event: React.KeyboardEvent) => onSubmit && event.key === 'Enter' && onSubmit();
  const derivedButtonLabel = (() => {
    if (buttonLabel) return buttonLabel;
    if (label) return `${label} (button)`;
    return 'Search button';
  })();

  return <div className={className}>
    <div className="relative mx-auto text-gray-600">
      <input
        aria-label={label || 'Search field'}
        className="border-2 h-10 px-5 pr-16 rounded-full text-sm hover:border-opacity-20 hover:border-secondary"
        type="search"
        id="search-bar"
        placeholder="Search"
        value={searchTerm || ''}
        onChange={event => setSearchTerm(event.target.value)} onKeyDown={handleSearchKeyDown} />
      <button
        id='search-button'
        type="submit"
        className="absolute right-0 top-0 mt-3 mr-4"
        onClick={onSubmit} 
        aria-label={derivedButtonLabel}
      >
        <img
          className="text-gray-600 h-4 w-4 fill-current"
          src={searchIcon}
          alt="Search"
          title="Search for products" />
      </button>
    </div>
  </div>;
};

export default SearchField;
